import React from "react";
import { XIcon, CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { beforeItems, afterItems } from "../data/content";
export function BeforeAfter() {
  return <section className="px-5 py-16 md:py-24" data-id="element-42" data-mp="3ogavnrgxf35u">
      <div className="mx-auto max-w-5xl" data-id="element-43" data-mp="3ofhwpco7lhy9">
        <h2 className="text-center font-display text-[30px] font-extrabold leading-tight text-ink md:text-5xl" data-id="element-44" data-mp="3sh34wkpst824">
          From a dentist who analyzes every case from scratch…{" "}
          <em className="text-plum-600" data-id="element-45" data-mp="3eo56sqlz11uv">to a clinician who follows a structured decision process.</em>
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-46" data-mp="34s24nkr4d37x">
          <div className="rounded-3xl border border-red-200 bg-red-50 p-6 md:p-8" data-id="element-47" data-mp="34tlil4paz26j">
            <div className="flex items-center gap-3" data-id="element-48" data-mp="39rmzpk364rfd">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-red-600 text-white" data-id="element-49" data-mp="2vrcbkot8tqxw">
                <XIcon className="h-5 w-5" strokeWidth={3} aria-hidden data-id="element-50" data-mp="30qoz7brxv21j" />
              </span>
              <h3 className="text-2xl font-black uppercase tracking-wide text-red-700" data-id="element-51" data-mp="x40vkbc50o5z">Before</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-52" data-mp="t3qi6dm0mvh3">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[16px] leading-snug text-red-950/80" data-id="element-53" data-mp="1739jamget6jw">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" strokeWidth={2.5} aria-hidden data-id="element-54" data-mp="123deikzw1b3a" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-plum-800 p-6 text-white shadow-xl shadow-plum-900/20 md:p-8" data-id="element-55" data-mp="9fr5uybszg9k">
            <div className="flex items-center gap-3" data-id="element-56" data-mp="o4xax2xbo0pd">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-go text-white" data-id="element-57" data-mp="jd5jkq6cdqy6">
                <CheckIcon className="h-5 w-5" strokeWidth={3} aria-hidden data-id="element-58" data-mp="3rsyxcx9agobj" />
              </span>
              <h3 className="text-2xl font-black uppercase tracking-wide" data-id="element-59" data-mp="3mtvt3f14um4m">
                After <span className="block text-sm font-bold normal-case tracking-normal text-plum-200" data-id="element-60" data-mp="3mrrpky75bp4v">with Implant Decision System™</span>
              </h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-61" data-mp="1vo9ew1z2p78e">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[16px] font-medium leading-snug text-white" data-id="element-62" data-mp="20hu3x4iouqvg">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-green-400" strokeWidth={3} aria-hidden data-id="element-63" data-mp="24hmd9jfwp11v" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10" data-id="element-64" data-mp="1ct2jizbcbct8">
          <CtaButton label="I want to analyze cases with a system" data-id="element-65" data-mp="1gstj9siuh39w" />
        </div>
      </div>
    </section>;
}